// extracted by mini-css-extract-plugin
export default {"header":"HighLightsAndLastMinute_header__Hgdqq","icon":"HighLightsAndLastMinute_icon__eev2I","empty":"HighLightsAndLastMinute_empty__KxYxT"};